import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { configureAuth, createAuthQueryClient } from '@jmvilaca-corp/auth-ui'
import NotificationsCard from './components/NotificationsCard'
import { router } from './routes/router'

configureAuth({
  appName: 'Calendar',
  navLinks: [{ to: '/calendars', label: 'Mes calendriers' }],
  adminLinks: [],
  sessionMinutes: 5,
  profileCards: [NotificationsCard],
})

const queryClient = createAuthQueryClient()

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
